import {
    useContext
} from 'react';

import {
    SavedTopicContext
} from '../contexts.js';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';


export default function useListeningSearchTimePeriodDuration(instanceId) {
    const plan = useCurationConfigValue('plan');
    const hasFullInstantSearch = plan.has_full_instant_search;

    const sharedTopic = useContext(SavedTopicContext);
    const isSampleTopic = sharedTopic?.isSampleTopic;

    const searchTimePeriod = (hasFullInstantSearch || isSampleTopic ? 30 : 7);

    return searchTimePeriod;
}
